import { Label } from "semantic-ui-react";

import "./PropertyImageScoreChip.scss";

interface PropertyImageScoreChipProps {
	score?: number;
	analysis?: string;
}

export default function PropertyImageScoreChip({ score, analysis }: PropertyImageScoreChipProps) {
	const formatValue = (): string => {
		if (score && analysis) {
			return `${score} - ${analysis}`;
		} else if (score != null) {
			return String(score);
		} else if (analysis) {
			return analysis;
		} else {
			return "N/A";
		}
	};

	return score ? (
		<Label className={`property-score-chip property-score-${score}`}>
			<div className={"property-image-container"}>
				<div className={"property-chip-decoration"}></div>
				<span>{formatValue()}</span>
			</div>
		</Label>
	) : (
		<>{formatValue()}</>
	);
}
